import styled from "styled-components";
import { colors } from "../../theme/color";

export const SuccessContainer = styled.div`
  width: 110%;
  padding-left: 20px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    padding: 0.5rem;
  }
`;

export const SuccessHeading = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 30px 0 0px 0;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    padding: 0;
  }
`;

export const SuccessHeadingText = styled.div`
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SuccessHeadingBigText = styled.div`
  margin-top: 10px;
  //margin-left: 20px;
  p {
  }
  h1 {
    color: #09005b;
    font-family: GT Walsheim Pro;
    font-size: 26px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.5px;
    text-align: left;
    flex-shrink: 0;
    @media screen and (min-width: 0px) and (max-width: 767px) {
      font-size: 1.125rem;
    }
  }
`;

export const DeleteButton = styled.button`
  width: 184px;
  height: 44px;
  color: #b00020;
  margin-top: 45px;
  border-radius: 10px;
  border: 1px solid #b00020;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  background-color: transparent;
  font-size: 1rem;
  font-weight: 500;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    margin: 0;
  }
`;

export const SuccessPaymentSummary = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: auto;
  margin: 0 auto;
  border-radius: 10px 10px 0px 0px;
  border: 1px;

  @media screen and (min-width: 0px) and (max-width: 767px) {
    margin-top: 1.5rem;
  }
  h2 {
    //margin-left: 20px;
    padding: 15px;
    font-family: GT Walsheim Pro;
    font-size: 18px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.02em;
    color: #09005b;
    @media screen and (min-width: 0px) and (max-width: 767px) {
      padding: 0;
      font-size: 1.125rem;
    }
  }
  p {
    margin-left: 20px;
    padding-top: 15px;
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0e0e0e;
  }
  @media screen and (min-width: 0px) and (max-width: 767px) {
    padding-top: 1rem;
    font-size: 1rem;
    height: auto;
  }
`;
export const LineDiv = styled.div`
  height: 2px;
  background: #e8eaed;
  width: 100%;
`;
export const CopyLink = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 20px;
  padding-top: 15px;

  @media screen and (min-width: 0px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 80%;
    margin: 0;
    padding: 0rem 1em 0rem 1rem;
  }
`;
export const CopyInput = styled.input`
  width: 589px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid #afafaf;
  padding-left: 10px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 100%;
    font-size: 0.875rem;
    padding: 0.3rem 1rem;
    text-overflow: ellipsis;
  }
`;

export const CopyLinkButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  border-radius: 20px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 95%;
    height: 5.525rem;
    align-items: flex-start;
  }
`;

export const Copy = styled.button`
  width: 114px;
  height: 36px;
  border-radius: 20px;
  border: 1px solid #ccf4cd;
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #008502;
  color: #ffffff;
  padding: 6px 12px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    font-size: 0.875rem;
    width: 7.125rem;
  }
`;

export const Share = styled.button`
  width: 114px;
  height: 36px;
  border-radius: 20px;
  border: 1px solid #ceccde;
  gap: 10px;
  display: flex;
  align-items: center;
  background-color: #ceccde;
  padding: 6px 12px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    font-size: 0.875rem;
    width: 7.125rem;
  }
`;

export const QRContainer = styled.button`
  width: 141px;
  height: 35px;
  border-radius: 20px;
  border: 1px solid #ceccde;
  gap: 10px;
  display: flex;
  align-items: center;
  background-color: #ceccde;
  padding: 6px 12px 6px 12px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    font-size: 0.875rem;
    width: 7.125rem;
  }
`;

export const PaymentSection = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto;
  padding-top: 30px;
  margin-bottom: 30px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const ProductBoxOut = styled.div`
  width: 46%;
  height: auto;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    align-self: center;
    width: 80%;
    padding: 1rem;
  }

  p {
    font-family: GT Walsheim Pro;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #0e0e0e;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 90%;
    padding: 1rem;
    align-self: center;
  }
`;
export const ProductBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  /* margin-left: 20px; */
  border-radius: 12px;
  border: 1px solid #e8eaed;
`;
export const PaymentBoxOut = styled.div`
  width: 487px;
  height: auto;
  margin-top: 50px;
  border-radius: 10px;
  border: 1px;
  background-color: #ecebf2;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 92%;
    margin-top: 1.88rem;
    align-self: center;
    padding: 1.5rem 1rem 1.5rem 1rem;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 90%;
    padding: 1rem;
    align-self: center;
  }
`;

export const Span01 = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
`;

export const FormGroup = styled.div`
  /* width: 352px; */
  height: auto;
  padding: 8px 16px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: bold;
`;

export const SubmitButton = styled.button`
  background-color: ${colors.ButtonColors.secondaryprimaryDisabledButton};
  color: #fff;
  margin-left: 20px;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #4ff916;
  }
  @media screen and (min-width: 0px) and (max-width: 767px) {
    margin-left: 0;
    width: 100%;
  }
`;
